module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "card card-box"
  }, [_c('reminders-list-widget', {
    attrs: {
      "default-filters": {
        categories: [1, 2, 3, 5, 6, 7]
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "card card-box"
  }, [_c('reminders-meetings-list')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0729aea4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents/Main/Reminders.vue
// module id = 661
// module chunks = 1